// import { FormattedMessage } from 'umi';
import React, { useContext } from 'react';
import Tooltips from '@/components/tooltips/Tooltips';
import { ChartsBoxStyles } from './ChartsBoxStyles';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import { useIntl } from 'umi';

const Head = (props) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const intl = useIntl();
  const { formatMessage } = intl;

  return (
    <ChartsBoxStyles theme={themeContext} brand={brandContext}>
      <div className="head">
        <div className="title">
          <div className="title_m">
            {formatMessage({ id: props.boxId })}
            <Tooltips boxId={props.boxId} extra={props.extra} />
          </div>
          <div className="title_r">
            {/* <HeadComponent
            boxId={boxId}
            chartBoxEvent={this.handleChartBoxEvent}
          // handelMore={this.handleMore}
          /> */}
            {props.children}
          </div>
        </div>
      </div>
    </ChartsBoxStyles>
  );
};

export default Head;
